import { navigate } from 'gatsby'
import { useCallback, useEffect } from 'react'

import { getOnboardingToastActions } from '../../../components/onboarding/OnboardingToastActions'
import {
  addDispensaryBasePathToPath,
  getDispensarySlugFromPath,
  removeDispensaryPrefixAndSlug,
  useDispensaryContext,
} from '../../dispensaries'
import { usePersistentToast } from '../../toasts/hooks/usePersistentToast'
import { useOnboardPatientClaim } from './useOnboardPatientClaim'

export const useOnboardingToast = () => {
  const { isOnboardingComplete } = useOnboardPatientClaim()
  const currentDispensary = useDispensaryContext()

  // If a patient is on a dispensary, don't display the onboarding toast
  // since they can complete onboarding via checkout
  const { shouldShowToast, shouldHideToast, showToast, hideToast, dismissToast } =
    usePersistentToast({
      toastId: 'onboarding',
      condition: () => !isOnboardingComplete && !currentDispensary,
      excludedPathPatterns: [/^\/onboarding/],
    })

  const navigateToOnboarding = useCallback(() => {
    // NOTE: extracting dispensary slug from current path, since dispensary context is not available,
    // Also getting path from window.location to get updated path without dependencies
    const path = typeof window !== 'undefined' ? window.location.pathname : '/'
    const onboardingPath = '/onboarding'
    const dispensarySlug = getDispensarySlugFromPath(path)
    const navigatePath = dispensarySlug
      ? addDispensaryBasePathToPath(dispensarySlug, onboardingPath)
      : onboardingPath
    const originPath = removeDispensaryPrefixAndSlug(path) || '/'
    navigate(`${navigatePath}?origin=${encodeURIComponent(originPath)}`)
  }, [])

  useEffect(() => {
    if (shouldShowToast) {
      showToast('Please select your practitioner to complete your onboarding', {
        variant: 'info',
        onClick: () => navigateToOnboarding(),
        action: getOnboardingToastActions({ dismissToast, navigateToOnboarding }),
      })
    }
  }, [dismissToast, navigateToOnboarding, shouldShowToast, showToast])

  useEffect(() => {
    if (shouldHideToast) {
      hideToast()
    }
  }, [shouldHideToast, hideToast])
}
